import React, { Fragment } from "react";
import Header from "../layouts/Header";
import Alert from "../layouts/Alert";
import CommentBox from "../layouts/CommentBox";
import Videos from "../pages/Videos";
const VideoTemplate = (props) => {
  return (
    <Fragment>
      <Header
        history={props.children.props.history}
        location={props.children.props.location}
      />
      <div className='row mr-2 ml-2 mb-2'>
        <div className=' col-xl-9 col-lg-9'>
          {props.children}
          <Alert />
        </div>
        <div
          className=' col-lg-3 col-xl-3 mt-2 '
          style={{ overflowY: "scroll", maxHeight: "730px" }}
        >
          <Videos
            match={props.children.props.match}
            location={props.children.props.location}
          />
        </div>
      </div>
      <CommentBox
        history={props.children.props.history}
        match={props.children.props.match}
      />
    </Fragment>
  );
};

export default VideoTemplate;
